import React, { useEffect, useState, useContext } from "react";
import PatientsTableInformation from "../../../components/PatientsInformationTable/PatientsInformationTable";
import { getRecords } from "../../../utils/services";
import Pagination from "../../../components/pagination";
import { isArrayEmpty, isNull, isSuperAdmin } from "../../../utils/utils";
import { HistoryFilterContext } from "../historyFilterContext";
import Loader from "../../../components/Loader/loader";
import { STORAGE_KEYS, getDataLocally } from "../../../utils/localStorage";
import { Box, Typography } from "@mui/material";


const UserHistory = (props) => {
  const [records, setRecords] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [showLoader, setLoader] = useState(false);
  const [page] = useState(1);
  const { filters } = useContext(HistoryFilterContext)
  const getLoggedInOrganization = getDataLocally(STORAGE_KEYS.LOGIN_ORGANIZATION);

  useEffect(() => {
    getPatientRecords(page)
  }, [page, filters]);
  
  async function getPatientRecords(pageNo) {
    setLoader(true)

    let param = {
      'page_no': pageNo,
      ...filters,
      "org_id": getLoggedInOrganization.org_id,
      "user_id": getLoggedInOrganization.user_id,
      "role_id": getLoggedInOrganization.role_id
    }
    await getRecords(param).then((res) => {
      if (!isNull(res.body)) {
        setRecords(res.body.data)
        setDataCount(res.body.dataCount)
      }
      setLoader(false)
    }).catch(()=>setLoader(false))
  }

  const onPageChange = async (pageNo) => {
    await getPatientRecords(pageNo)
  }

  // async function 
  return (
    <>
      <Loader show={showLoader} />
      <PatientsTableInformation patientData={records} />
      {!isArrayEmpty(records) ?
        <Pagination dataCount={dataCount} pageChangeCallBack={onPageChange} />
        :
        <Typography textAlign={"center"} paddingTop={8} variant="h6">
          There is no data Available
        </Typography>}
    </>
  )
};

export default UserHistory;
